import { List, ListItem, ListItemText, Typography } from "@mui/material";
import { Box } from "@mui/material";
import foodIcon from "../Assets/food3.png";

export default function FoodProducts() {
  const products = [
    "Milk Powder Full Cream & Low Fat",
    "Whey Milk Powder",
    "Creamer",
    "Black Leaf Tea",
    "Rooibos Leaf Tea",
    "Jams",
    "Golden Syrup",
    "Peanut Butter",
    "Baking Powder",
    "Lentils",
    "Green Split Peas",
    "Kidney Beans",
    "Stock Powders and Granules",
    "Gravy Powders Beef and Chicken",
    "Soup Powders Beef, Chicken, Minestrone and Beef & Onion",
    "Curry Powders Mild, Medium and Hot",
    "Spices BBQ, Chicken and Fish",
    "Mayonnaise",
    "Tomato Sauce",
    "Crushed Garlic",
    "Chillies",
    "Gherkins & Cucumbers",
    "Lemon Juice",
    "Vinegars",
    "Pepper in Grinders",
    "Salt in Grinders",
  ];
  return (
    <Box sx={{ textAlign: "center" }}>
      <img
        src={foodIcon}
        alt="Food Products Icon"
        style={{ height: 70, marginBottom: 16 }}
      />
      <Typography variant="h5" fontWeight="bold" gutterBottom color="#08b85dff">
        Range of Food Products
      </Typography>
      {/* <Typography variant="subtitle1" gutterBottom fontWeight="bold">
        Our pack sizes typically range from 500g to 25Kg or 500ml to 25L
        variants. We can also produce customised pack sizes and a variety of
        flavour variants based on volume requirements. .
      </Typography> */}
      <List
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          ml: 5,
          mt: 4,
        }}
      >
        {products.map((product, idx) => (
          <ListItem
            key={idx}
            disablePadding
            sx={{ width: "auto", justifyContent: "center" }}
          >
            <ListItemText primary={`• ${product}`} sx={{ textAlign: "left" }} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
